import { GridValidRowModel } from '@mui/x-data-grid-premium'
import { GridCellParams, GridColDef } from '@mui/x-data-grid-pro'
import React from 'react'
import DataGridCellWrapper from 'src/components/DataGrid/cells/DataGridCellWrapper/DataGridCellWrapper'

import styles from './HoverActionsCell.style'

interface HoverActionCellProps<Row extends GridValidRowModel> {
  params: GridCellParams<Row>
  renderCell: (params: GridCellParams<Row>) => React.ReactElement
}

const HoverActionsCell = <Row extends GridValidRowModel>(
  props: HoverActionCellProps<Row>,
) => {
  return (
    <DataGridCellWrapper css={styles} params={props.params}>
      {props.renderCell(props.params)}
    </DataGridCellWrapper>
  )
}

export default HoverActionsCell

export const hoverActionsCellColDef = <Row extends GridValidRowModel>(
  rowHoverActions: (params: GridCellParams<Row>) => React.ReactElement,
): GridColDef<Row> => ({
  field: 'hover-actions',
  resizable: false,
  sortable: false,
  hideable: false,
  minWidth: 1,
  maxWidth: 1,
  width: 1,
  disableColumnMenu: true,
  cellClassName: 'hover-actions',
  headerClassName: 'hover-actions-header',
  renderCell: (params) => (
    <HoverActionsCell params={params} renderCell={rowHoverActions} />
  ),
  renderHeader: (): React.ReactElement => <></>,
})
